import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { PROBE_GET_TREE_REQUEST } from 'js/constants/actionTypes';
import { probeClearAll, probeToggleTreeNode } from 'js/actions';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

export default function useProbe() {
  const probe = useSelector((state: any) => state.probe);
  const loading = useIsLoading(PROBE_GET_TREE_REQUEST);
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();

  const getProbeData = useCallback(
    (credentialId: number) => {
      const probeResponse = probe[credentialId];
      return {
        data: probeResponse?.nestedProbeTree,
        flatData: probeResponse?.tree,
        loading,
        error: probeResponse?.error,
        lastUpdated: probeResponse?.treeLastUpdatedAt,
        ...probeResponse,
        probeSample: probeResponse,
      };
    },
    [probe, loading],
  );

  const clearAllProbe = useCallback(() => {
    dispatch(probeClearAll());
  }, []);

  const toggleTreeNode = useCallback((credentialId, node) => {
    dispatch(probeToggleTreeNode(credentialId, node));
  }, []);

  return {
    getProbeData,
    clearAllProbe,
    toggleTreeNode,
  };
}
